/* eslint-disable react/destructuring-assignment */
import React from 'react';

import { AlertContainer } from './styled';
import { IconSizeMap, SpacingMap } from './constants';

import { Text } from '../../Text';
import { theme } from '../../../theme';
import { Stack } from '../../Stack';
import { Button } from '../../Button';
import { CrossIcon } from '../../../icons';
import { ColourMap, IconMap } from '../constants';
import { AlertProps } from './types';

export const Alert = ({
  size = 'base',
  variant = 'default',
  colours: passedColours,
  rightActions,
  rightActionsSlot,
  title,
  titleSlot,
  messageSlot,
  message,
  children,
  iconSlot,
  onClickClose,
  ...divProps
}: AlertProps) => {
  const colours = passedColours ?? ColourMap[variant];
  const IconSlot = iconSlot || IconMap[variant];

  const isXsSize = size === 'xs';

  return (
    <AlertContainer
      colours={colours}
      direction="horizontal"
      alignX="between"
      spacing="0"
      {...divProps}
    >
      <Stack
        direction="horizontal"
        alignY={isXsSize ? 'center' : 'start'}
        style={{ margin: SpacingMap[size], gap: SpacingMap[size] }}
        spacing={0}
      >
        <IconSlot
          aria-hidden
          style={{
            minWidth: IconSizeMap[size],
            minHeight: IconSizeMap[size],
            width: IconSizeMap[size],
            height: IconSizeMap[size],
          }}
          color={colours.primary}
        />

        {children || (
          <Stack direction="vertical" spacing={isXsSize ? 0 : 'xs'}>
            {titleSlot || (
              <Text
                variant={isXsSize ? 'bodySmallBold' : 'bodyBold'}
                style={size === 'base' ? { lineHeight: '24px' } : {}}
              >
                {title}
              </Text>
            )}
            {messageSlot || <Text variant={isXsSize ? 'bodySmall' : 'body'}>{message}</Text>}
          </Stack>
        )}
      </Stack>

      <Stack
        direction="horizontal"
        alignX="end"
        spacing={0}
        style={{
          margin: isXsSize ? undefined : theme.sizes[3],
          gap: isXsSize ? undefined : SpacingMap[size],
          alignItems: 'center',
        }}
      >
        {rightActionsSlot}

        {rightActions && (
          <Stack alignY="center" spacing={0} style={{ gap: SpacingMap[size] }}>
            {rightActions.map(({ label, ...actionProps }) => (
              <Button key={label} type="button" size="sm" {...actionProps}>
                {label}
              </Button>
            ))}
          </Stack>
        )}

        {onClickClose && (
          <Stack
            alignY={isXsSize ? 'center' : 'start'}
            style={{ height: '100%', padding: isXsSize ? theme.sizes.xs : undefined }}
          >
            <Button
              variant="flat"
              iconSlot={<CrossIcon />}
              onClick={onClickClose}
              aria-label="Close"
              size="sm"
            />
          </Stack>
        )}
      </Stack>
    </AlertContainer>
  );
};
